<p>
    <enhanced-help componentName="notice-types-list" [compact]="true">
    </enhanced-help>
</p>

<div *ngIf="noticeTypes != null">
    <table class="table">
        <thead>
            <tr>
                <th style="width: 30%"></th>
                <th>
                    <div class="checkbox pull-right" style="margin: 0">
                        <mat-slide-toggle
                            [(ngModel)]="showArchived"
                            [ngModelOptions]="{ standalone: true }"
                        >
                            Show archived LOTAM types?
                        </mat-slide-toggle>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let notice of noticeTypes">
                <tr *ngIf="showArchived || !notice.archived" class="data">
                    <td>
                        <editable
                            *ngIf="!isReadOnlyAdmin"
                            [initialContext]="{
                                name: notice.name,
                                description: notice.description,
                                noticeId: notice.id,
                                colour: notice.colour
                            }"
                            [confirmationButtons]="true"
                            [updateFn]="updateNoticeType"
                            [disabled]="working"
                        >
                            <ng-template viewMode>
                                <div class="horizontal-container">
                                    <div class="status-icon-block right-buffer">
                                        <div class="status-icon">
                                            <div
                                                *ngIf="notice.colour"
                                                [ngStyle]="{
                                                    'background-color':
                                                        notice.colour
                                                }"
                                            ></div>
                                        </div>
                                    </div>
                                    <strong>{{ notice.name }}</strong>
                                    <span class="text-muted">
                                        -
                                        {{ notice.description }}</span
                                    >
                                </div>
                            </ng-template>
                            <ng-template editMode let-context="context">
                                <div class="form-group">
                                    <label>Name</label>
                                    <input
                                        type="text"
                                        [(ngModel)]="context.name"
                                        class="form-control"
                                        editableOnEnter
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Description</label>
                                    <input
                                        type="text"
                                        [(ngModel)]="context.description"
                                        class="form-control"
                                        editableOnEnter
                                    />
                                </div>
                                <div class="form-group">
                                    <label>Colour</label>
                                    <div
                                        class="horizontal-container vertical-align"
                                    >
                                        <div class="input-group right-buffer">
                                            <input
                                                matInput
                                                id="color-input"
                                                type="color"
                                                class="form-control colour-input"
                                                [ngClass]="{
                                                    'active-input-group':
                                                        context.colour
                                                }"
                                                [(ngModel)]="context.colour"
                                            />
                                            <span
                                                class="input-group-addon"
                                                [ngClass]="{
                                                    'active-input-group':
                                                        context.colour
                                                }"
                                                >Pick a colour</span
                                            >
                                        </div>
                                        &nbsp;or&nbsp;
                                        <button
                                            type="button"
                                            class="btn btn-pill btn-sm left-buffer"
                                            [ngClass]="{
                                                active: !context.colour
                                            }"
                                            (click)="context.colour = null"
                                        >
                                            No Colour
                                        </button>
                                    </div>
                                </div>
                            </ng-template>
                        </editable>
                        <div *ngIf="isReadOnlyAdmin">
                            {{ notice.name }}
                        </div>
                    </td>
                    <td class="actions">
                        <ng-container *ngIf="!isReadOnlyAdmin">
                            <button
                                *ngIf="!notice.archived"
                                type="button"
                                class="btn btn-tertiary"
                                (click)="archiveNoticeType(notice)"
                                [disabled]="working"
                                tooltip="Archive"
                                placement="left"
                            >
                                <span class="fal fa-eye-slash"></span>
                            </button>

                            <button
                                *ngIf="notice.archived"
                                type="button"
                                class="btn btn-tertiary"
                                (click)="unArchiveNoticeType(notice)"
                                [disabled]="working"
                                tooltip="Unarchive"
                                placement="left"
                            >
                                <span class="fal fa-eye"></span>
                            </button>
                        </ng-container>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>
<div>
    <h4 class="section-heading">
        <span>Create new LOTAM Type</span>
        <div></div>
    </h4>
    <form (submit)="addNoticeType()" [formGroup]="createFormGroup">
        <div class="form-group">
            <label>Name</label>
            <input type="text" formControlName="name" class="form-control" />
        </div>
        <div class="form-group">
            <label>Description</label>
            <input
                type="text"
                formControlName="description"
                class="form-control"
            />
        </div>
        <div class="form-group">
            <label>Colour</label>
            <div class="horizontal-container vertical-align">
                <div class="input-group right-buffer">
                    <input
                        matInput
                        id="color-input"
                        type="color"
                        class="form-control colour-input"
                        [ngClass]="{
                            'active-input-group': createFormGroup.value.colour
                        }"
                        formControlName="colour"
                    />
                    <span
                        class="input-group-addon"
                        [ngClass]="{
                            'active-input-group': createFormGroup.value.colour
                        }"
                        >Pick a colour</span
                    >
                </div>
                &nbsp;or&nbsp;
                <button
                    type="button"
                    class="btn btn-pill btn-sm left-buffer"
                    [ngClass]="{
                        active: !createFormGroup.value.colour
                    }"
                    (click)="clearColourSelection()"
                >
                    No Colour
                </button>
            </div>
        </div>
        <button
            type="submit"
            class="btn btn-primary pull-right"
            [disabled]="working || createFormGroup.invalid || isReadOnlyAdmin"
        >
            Add
        </button>
    </form>
</div>
